import type { ReactElement } from 'react'

import { Trans } from '@lingui/react'
import { useAtom } from 'jotai'

import { IconButton } from '@twisto/components/atoms/button'
import { Flex } from '@twisto/components/atoms/flex'
import { Checkbox } from '@twisto/components/molecules/checkbox'
import { ValidationBox } from '@twisto/components/molecules/validation-box'
import { useOpen } from '@twisto/hooks'
import { TooltipOutlineIcon } from '@twisto/icons'

import { PepConfirmationModal } from '../pep-confirmation-modal'
import { PepDescriptionModal } from '../pep-description-modal'
import { submittingFlowFormAtom } from '../submitting-atom'

import * as styles from './pep-checkbox.styles'

type Props = {
  confirmationModalOpened: boolean
  description: ReactElement
  hasWarning: boolean
  name: string
  onConfirm: () => void
  onClose: () => void
}

export const PepCheckbox = ({
  confirmationModalOpened,
  description,
  hasWarning,
  name,
  onConfirm,
  onClose,
}: Props) => {
  const {
    isOpen: isPepDescriptionOpen,
    handleClose: handlePepDescriptionClose,
    handleOpen: handlePepDescriptionOpen,
  } = useOpen()

  const [submitting] = useAtom(submittingFlowFormAtom)

  return (
    <>
      <ValidationBox
        isVisible={hasWarning}
        message={<Trans id="flow.pepCheckbox.validationBox.warning" />}
      >
        <Flex alignItems="center" css={styles.checkboxWrapper} wrap="noWrap">
          <Checkbox
            css={styles.checkbox}
            id="isPoliticallyExposed"
            label={description}
            name={name}
          />

          <IconButton
            color="ghost"
            defaultTooltip="displayMore"
            icon={TooltipOutlineIcon}
            size="small"
            onClick={handlePepDescriptionOpen}
          />
        </Flex>
      </ValidationBox>
      <PepConfirmationModal
        opened={confirmationModalOpened && !submitting}
        onClose={onClose}
        onConfirm={onConfirm}
        onPepDescriptionOpen={handlePepDescriptionOpen}
      />
      <PepDescriptionModal
        opened={isPepDescriptionOpen}
        onClose={handlePepDescriptionClose}
      />
    </>
  )
}
